<template>
	<div class="app-navbar">
		<div class="app-wrapper">
			<div class="app-navbar-social">
				<template v-for="(media, index) in companyData.socialMedia">
					<a
					:key="index"
					v-if="media.name === 'waze'"
					class="social-icon mobile"
					target="_blank"
					:href="`waze://?ll=${coords.lat},${coords.lng}&navigate=yes`">
					<simple-svg 
						:filepath="media.icon"
						:height="'14px'"
						:fill="'#fff'" />
				</a>
				<a
					:key="index"
					v-else-if="media.name === 'whatsapp'"
					class="social-icon mobile"
					target="_blank"
					:href="`whatsapp://send?phone=51${media.link}`">
					<simple-svg 
						class="social-icon"
						:filepath="media.icon"
						:height="'14px'"
						:fill="'#fff'" />
				</a>
				<a
					:key="index"
					v-else
					:href="media.link"
					class="social-icon">
					<simple-svg 
						class="social-icon"
						:filepath="media.icon"
						:height="'14px'"
						:fill="'#fff'"
					/>
				</a>
				</template>
			</div>
			<div class="app-navbar-links">
				<ul class="items-links">
					<li class="item-link">
						<a 
							href="http://138.122.108.170:8880/ecuafactportal/" 
							target="_blank">Clientes</a>
					</li>
					<li class="item-link">
						<a 
							href="http://138.122.108.170:8880/ecuafactportal/" 
							target="_blank">Proveedores</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
function data() {
	return {
		coords: {
			lat: -12.0398200,
			lng: -77.0745303,
		},
	};
}

export default {
	name: 'navbar',
	data,
	props: {
		companyData: {
			default: () => {},
			type: Object,
		},
	},
};
</script>

<style lang="scss" scoped>
	.app-navbar {
		@include font-size(13);
		background: map-get($colors, black-dark);
		color: map-get($colors, white);
		padding: 15px;
		position: fixed;
		width: 100%;
		z-index: 110;
	}

	.app-navbar-social {
		display: none;

		> .social-icon {
			margin-right: 15px;

		}

		.mobile {
			display: block;
		}
	}

	.app-navbar-links {
		.items-links {
			@include display-flex();
			justify-content: space-between;
		}

		.link-languages {
			display: none;
		}
	}

	.simple-svg-wrapper {
		height: 13px;
	}

	.select-language {
		@include appearance(none);
		background: transparent;
		border: none;
		color: white;
		cursor: pointer;
		outline: none;
		position: relative;
		width: 31px;
	}

	.wrapper-select-languages {
		position: relative;
		width: 31px;

		&::before {
			border-left: 6px solid transparent;
			border-radius: .8px;
			border-right: 6px solid transparent;
			border-top: 6px solid map-get($colors, white);
			bottom: 0;
			content: "";
			cursor: pointer;
			height: 0;
			margin: auto;
			position: absolute;
			right: 0;
			top: 0;
		}
	}

	@media screen and (min-width: 1024px) {
		.app-navbar-social {
			@include flex-center();

			> .social-icon {
				margin-right: 15px;

			}

			.mobile {
				display: none;
			}
		}

		.app-navbar-links {
			.link-languages {
				display: block;
			}
		}

		.app-wrapper {
			@include display-flex();
			justify-content: space-between;
		}

		.item-social {
			margin-right: 18px;
		}

		.item-link {
			margin-right: 25px;
		}

		.item-link:last-child {
			margin-right: 0;
		}
	}
</style>




// WEBPACK FOOTER //
// src/components/commons/navbar.vue